import { useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

const ERRORS = {
  "auth/unauthorized-domain": "Dominio non autorizzato in Firebase: aggiungi questo dominio nei Domini autorizzati",
  "auth/network-request-failed": "Connessione assente, riprova",
  "auth/operation-not-allowed": "Accesso Google non attivo su Firebase",
  "auth/internal-error": "Errore di Google, riprova tra poco",
};

export default function Login() {
  const { user, loading, login } = useAuth();
  const [params] = useSearchParams();
  const next = params.get("next") || "/";
  const [busy, setBusy] = useState(false);
  if (!loading && user) return <Navigate to={next} replace />;
  const onLogin = async () => {
    setBusy(true);
    try {
      await login();
    } catch (e) {
      console.error("Firebase login error", e?.code, e?.message);
      toast.error(e?.response ? errMsg(e, "Accesso non riuscito") : ERRORS[e?.code] || `Accesso con Google non riuscito${e?.code ? ` (${e.code})` : ""}`);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="card-mc overflow-hidden text-center shadow-[6px_6px_0_#0b0b0f] border-2 !border-[#0b0b0f]">
        <div className="flex justify-center bg-[#0b0b0f] px-4 py-6">
          <Logo className="h-48 sm:h-56" testId="login-logo" />
        </div>
        <div className="h-1.5 bg-[#FFD60A]" />
        <div className="p-8 pt-6">
        <h1 className="text-2xl font-extrabold">Accedi al negozio</h1>
        <p className="mt-2 text-sm text-muted-foreground">Accedi con Google per pagare, salvare l'indirizzo e vedere i tuoi ordini.</p>
        <button data-testid="google-login-button" className="btn-mc mt-6 w-full !py-3" disabled={busy} onClick={onLogin}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <i className="fa-brands fa-google" aria-hidden="true" />} Continua con Google
        </button>
        </div>
      </div>
    </div>
  );
}
